import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class LanceCartaConsorcioService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Lance da Carta Consórcio por id
     * @param id ID da Lance da Carta Consórcio
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "consorcio/carta-lance/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Lance da Carta Consórcio
     * @param id ID da Lance da Carta Consórcio
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "consorcio/carta-lance"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Lance da Carta Consórcio
     * @param id ID da Lance da Carta Consórcio
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "consorcio/carta-lance"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Lance da Carta Consórcio
     * @param id ID da Lance da Carta Consórcio
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "consorcio/carta-lance/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Lance da Carta Consórcio
     * @param params Json Lance da Carta Consórcio
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "consorcio/carta-lance", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Lance da Carta Consórcio
     * @param params Json Lance da Carta Consórcio
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "consorcio/carta-lance/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
